import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import moment from "moment";

// import CompleteAnimation from "./Animation.json";
import CompleteAnimation from "../../../indi-plan/components/CompleteAnimation.json";
import CustomButton from "../../../../common/CustomButton";

import "./style.css";
import { connect } from "react-redux";

function SendSuccess(props) {

    const [expiry, setExpiry] = useState(null);
    const { account } = props.User;

    useEffect(() => {
        if (account?.billingInfo?.currentPeriodEndsAt) {
            setExpiry(e => moment(new Date(account?.billingInfo?.currentPeriodEndsAt)).format("LL"));
        }

    }, [account?.billingInfo]);

    return (
        <div id="success-page-promo">
            <div id="spp-apm-icon-wrapper">
                <div id="spp-apm-icon">
                    <Lottie
                        id="spp-apm-icon-animation"
                        animationData={CompleteAnimation}
                        loop={true}
                    />

                    <div id="spp-apm-icon-bg-floater" />
                </div>

                <div id="spp-apm-text">
                    <h3>Email Sent Successfully!</h3>
                </div>

                <CustomButton style={{ marginTop: "40px" }} onClick={() => {
                    props.close();
                }}>Continue</CustomButton>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});
export default connect(mapStateToProps, {

})(SendSuccess);
